import Vue from 'vue'
import 'normalize.css'

import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'
import watermark from '@/utils/watermark'

import VueVideoPlayer from 'vue-video-player'

import '@/icons/components/index'
import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/styles/ruoyi.scss'

Vue.config.productionTip = false
Vue.prototype.$watermark = watermark

Vue.use(ElementUI)

Vue.use(VueVideoPlayer)

Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})
Vue.component('svg-icon', SvgIcon)

// 全局注册scroll指令
Vue.directive('scroll', {
  inserted: function(el, binding) {
    const selectDropdown: any = el.querySelector(
      '.el-select-dropdown .el-select-dropdown__wrap'
    )
    selectDropdown.addEventListener('scroll', binding.value)
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
